export const getPercent = (a: number, b: number, decimals?: number) =>
  ((b / (a || 1)) * 100).toFixed(decimals || 2)
